module.exports = __webpack_public_path__ + "img/数显热熔机.c4d6c891.png";